import React from 'react';

function TermsOfUse() {
  return (
    <div className="container py-5 mt-5 pt-4">
      <h1 className="mb-4">Terms of Use</h1>

      <p>
        By accessing or using this website, you agree to comply with and be bound by the following terms and conditions.
      </p>

      <h4>1. Use of Website</h4>
      <p>
        This website is intended for academic, research, and educational use. You may not use the site for any unlawful or prohibited activity.
      </p>

      <h4>2. Intellectual Property</h4>
      <p>
        All content published on this website, including articles, graphics, and logos, are the property of their respective authors and publishers. Unauthorized use or reproduction is strictly prohibited.
      </p>

      <h4>3. Paper Submission</h4>
      <p>
        By submitting a paper, you confirm that the work is original, not under review elsewhere, and that all co-authors have approved the submission. The journal reserves the right to review, edit, or reject submissions.
      </p>

      <h4>4. Disclaimers</h4>
      <p>
        The content on this website is provided "as is" without any warranties. <strong>Journal of Asia Entrepreneurship and Sustainability</strong> is not responsible for any loss or damage resulting from reliance on the published content.
      </p>

      <h4>5. External Links</h4>
      <p>
        Our website may contain links to third-party websites. We are not responsible for the content or privacy practices of those sites.
      </p>

      <h4>6. Termination</h4>
      <p>
        We reserve the right to restrict or terminate your access to our website at any time without notice.
      </p>
    </div>
  );
}

export default TermsOfUse;
